var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wrapper row no-margin",
      staticStyle: { height: "100%", display: "flow-root" }
    },
    [
      _c("header", { staticClass: "row align-items-center no-margin" }, [
        _c("div", { staticClass: "col" }, [
          _c(
            "button",
            {
              staticClass: "btn no-bg",
              on: {
                click: function($event) {
                  return _vm.setPosSection("choose-product")
                }
              }
            },
            [_c("i", { staticClass: "fas fa-times" })]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row mt-3 mb-3",
          staticStyle: { "margin-left": "0", "margin-right": "0" }
        },
        [
          _c(
            "div",
            {
              staticClass: "col-4 status",
              staticStyle: { position: "relative", top: "15px" }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("message.customerlist")) +
                  " (" +
                  _vm._s(_vm.customers.length) +
                  ")\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-8" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-web btn-sm",
                staticStyle: { float: "right", "margin-left": "15px" },
                on: {
                  click: function($event) {
                    return _vm.openModal()
                  }
                }
              },
              [
                _c("i", { staticClass: "fas fa-user-plus" }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.newcustomer")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.textSearch,
                  expression: "textSearch"
                }
              ],
              staticClass: "form-control form-control-sm",
              staticStyle: {
                float: "right",
                width: "180px",
                padding: ".25em .25em .18em .25em"
              },
              attrs: {
                placeholder: _vm.$t("placeholder.search"),
                type: "text"
              },
              domProps: { value: _vm.textSearch },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.textSearch = $event.target.value
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "col-12 no-padding items" },
        [
          _vm.customer_id
            ? _c(
                "li",
                {
                  staticClass: "row no-margin item text-danger",
                  on: {
                    click: function($event) {
                      return _vm.onDeselectCustomer()
                    }
                  }
                },
                [
                  _c("span", [
                    _c("i", {
                      staticClass: "fas fa-ban",
                      staticStyle: {
                        "margin-right": "7px",
                        "margin-left": "3px",
                        "font-size": "13px"
                      }
                    }),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.deselected")) +
                        "\n      "
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(
            _vm.searchResults.length > 0 ? _vm.searchResults : _vm.customers,
            function(item, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "row no-margin item",
                  class: [
                    {
                      active:
                        item.customer_id == _vm.customer_id ? "active" : ""
                    }
                  ],
                  on: {
                    click: function($event) {
                      return _vm.onSelectedCustomer({
                        customer_id: item.customer_id,
                        customer_new: false
                      })
                    }
                  }
                },
                [
                  _c("div", { staticClass: "col" }, [
                    _vm._v(
                      "\n        " + _vm._s(item.customer_name) + "\n      "
                    )
                  ])
                ]
              )
            }
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "createModal",
            tabindex: "-1",
            role: "dialog",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-lg",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("message.newcustomer")) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.$store.state.app.loading
                    ? _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button", "aria-label": "Close" },
                          on: {
                            click: function($event) {
                              return _vm.closeModal()
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("section", [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.customername")) + " *")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.name,
                          expression: "form.name"
                        }
                      ],
                      ref: "name",
                      staticClass: "form-control",
                      class: [_vm.bindClass.name],
                      attrs: { type: "text" },
                      domProps: { value: _vm.form.name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "name", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("message.pleasefillcustomername")) +
                          "\n            "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("section", [
                    _c("label", [_vm._v(_vm._s(_vm.$t("message.gender")))]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.gender,
                            expression: "form.gender"
                          }
                        ],
                        staticClass: "custom-select",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.form,
                              "gender",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(_vm._s(_vm.$t("placeholder.select")))
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "m" } }, [
                          _vm._v(_vm._s(_vm.$t("message.male")))
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "f" } }, [
                          _vm._v(_vm._s(_vm.$t("message.female")))
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "section",
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.birthdate")))
                      ]),
                      _vm._v(" "),
                      _c("BaseInputDatePicker", {
                        model: {
                          value: _vm.form.birthdate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "birthdate", $$v)
                          },
                          expression: "form.birthdate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("section", [
                    _c("label", [_vm._v(_vm._s(_vm.$t("message.email")))]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.email,
                          expression: "form.email"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.form.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "email", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("section", [
                    _c("label", [_vm._v(_vm._s(_vm.$t("message.tel")))]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.tel,
                          expression: "form.tel"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.form.tel },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "tel", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("section", [
                    _c("label", [_vm._v(_vm._s(_vm.$t("message.note")))]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.note,
                          expression: "form.note"
                        }
                      ],
                      staticClass: "form-control",
                      domProps: { value: _vm.form.note },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "note", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "section",
                    [
                      _c(
                        "vs-checkbox",
                        {
                          staticStyle: { float: "left", margin: "0 5px 0 0" },
                          model: {
                            value: _vm.form.checkAutoSelected,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "checkAutoSelected", $$v)
                            },
                            expression: "form.checkAutoSelected"
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("message.autoselectedthiscustomer")
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                !_vm.$store.state.app.loading
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.closeModal()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-web",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.save()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.ok")))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.app.loading
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button", disabled: "" }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _vm._m(0)
                    ])
                  : _vm._e()
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab6f57ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab6f57ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/main/include/CustomerList.vue
// module id = null
// module chunks = 